{
  "AUTOMATION": {
    "HEADER": "Automatyzacja",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Dodaj regułę automatyzacji",
    "LOADING": "Pobieranie reguł automatyzacji",
    "ADD": {
      "TITLE": "Dodaj regułę automatyzacji",
      "SUBMIT": "Stwórz",
      "CANCEL_BUTTON_TEXT": "Anuluj",
      "FORM": {
        "NAME": {
          "LABEL": "Nazwa reguły",
          "PLACEHOLDER": "Wprowadź nazwę reguły",
          "ERROR": "Nazwa jest wymagana"
        },
        "DESC": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Wprowadź opis reguły",
          "ERROR": "Opis jest wymagany"
        },
        "EVENT": {
          "LABEL": "Zdarzenie",
          "PLACEHOLDER": "Wybierz jedno",
          "ERROR": "Zdarzenie jest wymagane"
        },
        "PHASE": {
          "LABEL": "Faza"
        },
        "ORDER": {
          "LABEL": "Kolejność",
          "ERROR": "Kolejność jest wymagana"
        },
        "CONDITIONS": {
          "LABEL": "Warunki"
        },
        "ACTIONS": {
          "LABEL": "Akcje"
        }
      },
      "CONDITION_BUTTON_LABEL": "Dodaj warunek",
      "ACTION_BUTTON_LABEL": "Dodaj akcję",
      "API": {
        "SUCCESS_MESSAGE": "Reguła automatyzacji została dodana",
        "ERROR_MESSAGE": "Nie udało się utworzyć reguły automatyzacji, spróbuj ponownie później"
      }
    },
    "LIST": {
      "404": "Nie znaleziono reguł automatyzacji",
      "TABLE_HEADER": {
        "PHASE": "Faza",
        "ORDER": "Kolejność",
        "NAME": "Imię",
        "DESCRIPTION": "Opis",
        "ACTIVE": "Aktywne",
        "CREATED_ON": "Utworzona dnia",
        "WAIT": "Oczekiwanie"
      },
      "TABS": {
        "ALL": "Wszystkie",
        "INSTANT": "Przy zdarzeniu",
        "DELAYED": "Z opóźnieniem"
      },
      "WAITS": "Czeka {duration}"
    },
    "DELETE": {
      "TITLE": "Usuń regułę automatyzacji",
      "SUBMIT": "Usuń",
      "CANCEL_BUTTON_TEXT": "Anuluj",
      "CONFIRM": {
        "TITLE": "Potwierdź usunięcie",
        "MESSAGE": "Czy na pewno chcesz usunąć ",
        "YES": "Tak, usuń ",
        "NO": "Nie, zachowaj "
      },
      "API": {
        "SUCCESS_MESSAGE": "Reguła automatyzacji została usunięta",
        "ERROR_MESSAGE": "Nie udało się usunąć reguły automatyzacji, spróbuj ponownie później"
      }
    },
    "EDIT": {
      "TITLE": "Edytuj regułę automatyzacji",
      "SUBMIT": "Aktualizuj",
      "CANCEL_BUTTON_TEXT": "Anuluj",
      "API": {
        "SUCCESS_MESSAGE": "Reguła automatyzacji została zaktualizowana",
        "ERROR_MESSAGE": "Nie udało się zaktualizować reguły automatyzacji, spróbuj ponownie później"
      }
    },
    "CLONE": {
      "TOOLTIP": "Klonuj",
      "API": {
        "SUCCESS_MESSAGE": "Reguła automatyzacji została sklonowana pomyślnie",
        "ERROR_MESSAGE": "Nie udało się sklonować reguły automatyzacji, spróbuj ponownie później"
      }
    },
    "FORM": {
      "EDIT": "Edytuj",
      "CREATE": "Stwórz",
      "DELETE": "Usuń",
      "CANCEL": "Anuluj",
      "RESET_MESSAGE": "Zmiana typu zdarzenia spowoduje zresetowanie dodanych warunków i zdarzeń poniżej"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Musisz mieć co najmniej jeden warunek, aby zapisać",
      "CONTACT_CUSTOM_ATTR_LABEL": "Niestandardowe atrybuty kontaktu",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Niestandardowe atrybuty rozmowy"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Musisz mieć co najmniej jedną akcję, aby zapisać",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Wprowadź swoją wiadomość tutaj",
      "TEAM_DROPDOWN_PLACEHOLDER": "Wybierz zespoły",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Wybierz skrzynkę e-mail i adres nadawcy",
      "SUBJECT_INPUT_PLACEHOLDER": "Temat wiadomości e-mail",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Wybierz skrzynkę SMS, z której zostanie wysłany SMS",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Wpisz treść SMS-a",
      "SMS_COUNTER": "{length}/{limit} znaków, {segments} SMS (przed uzupełnieniem zmiennych)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Aktywuj regułę automatyzacji",
      "DEACTIVATION_TITLE": "Wyłącz regułę automatyzacji",
      "ACTIVATION_DESCRIPTION": "Ta akcja spowoduje aktywację reguły automatyzacji '{automationName}'. Czy na pewno chcesz kontynuować?",
      "DEACTIVATION_DESCRIPTION": "Ta akcja spowoduje deaktywację reguły automatyzacji '{automationName}'. Czy na pewno chcesz kontynuować?",
      "ACTIVATION_SUCCESFUL": "Reguła automatyzacji została pomyślnie aktywowana",
      "DEACTIVATION_SUCCESFUL": "Reguła automatyzacji została pomyślnie wyłączona",
      "ACTIVATION_ERROR": "Nie można aktywować reguły automatyzacji, spróbuj ponownie później",
      "DEACTIVATION_ERROR": "Nie można wyłączyć reguły automatyzacji, spróbuj ponownie później",
      "CONFIRMATION_LABEL": "Tak",
      "CANCEL_LABEL": "Nie"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Nie udało się przesłać załącznika, spróbuj ponownie",
      "LABEL_IDLE": "Prześlij załącznik",
      "LABEL_UPLOADING": "Przesyłanie...",
      "LABEL_UPLOADED": "Przesłano pomyślnie",
      "LABEL_UPLOAD_FAILED": "Nie udało się przesłać załącznika"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Wartość jest wymagana",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Wartość musi być między 0 a 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required",
      "ORDER_REQUIRED": "Kolejność jest wymagana",
      "ORDER_MUST_BE_AT_LEAST_ONE": "Kolejność musi wynosić co najmniej 1",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Ta akcja działa tylko wtedy, gdy faza reguły jest ustawiona na \"Przed etykietowaniem\".",
      "SKIP_AUTO_LABELING": "Ta akcja działa tylko wtedy, gdy faza reguły jest ustawiona na \"Przed etykietowaniem\".",
      "MOVE_CONVERSATION_TO_INBOX": "Do skrzynki e-mail można przenieść tylko rozmowy e-mail i rozmowy z czatu na stronie, czat tylko wtedy, gdy kontakt ma adres e-mail. W przeciwnym razie rozmowa nie zostanie przeniesiona, a zamiast tego zostanie dodana notatka prywatna.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Rozpoczyna nową rozmowę z kontaktem w wybranej skrzynce e-mail, wysyła mu wiadomość e-mailem i oznacza rozmowę jako rozwiązaną. Dzieje się tak przy każdym uruchomieniu reguły. Jeśli kontakt nie ma adresu e-mail, nic nie zostanie wysłane, a zamiast tego zostanie dodana prywatna notatka.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Rozpoczyna nową rozmowę z kontaktem w wybranej skrzynce SMS, wysyła mu wiadomość jako SMS i oznacza rozmowę jako rozwiązaną. Dzieje się tak przy każdym uruchomieniu reguły. Wiadomość jest zwykłym tekstem bez załączników. Jeśli kontakt nie ma numeru telefonu, nic nie zostanie wysłane, a zamiast tego zostanie dodana prywatna notatka."
    },
    "NOTICES": {
      "AI_PROMPT": "Każda pojedyncza ewaluacja jest płatna.",
      "INCOMING_MESSAGES_COUNT": "Odnosi się to do liczby wiadomości przychodzących w rozmowie.",
      "OUTGOING_MESSAGES_COUNT": "Odnosi się to do liczby wiadomości wychodzących w rozmowie."
    },
    "PHASE": {
      "BEFORE_LABELING": "Przed etykietowaniem",
      "AFTER_LABELING": "Po etykietowaniu"
    },
    "NONE_OPTION": "Brak",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Wiadomość przychodząca",
      "OUTGOING": "Wiadomość wychodząca",
      "PRIVATE": "Notatka prywatna",
      "AI_SUMMARY": "Podsumowanie AI"
    },
    "YES_NO_VALUES": {
      "YES": "Tak",
      "NO": "Nie"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Wiadomość bezpośrednia na Instagramie",
      "FACEBOOK_COMMENT": "Komentarz na Facebooku"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Utworzono rozmowę",
      "CONVERSATION_UPDATED": "Zaktualizowano rozmowę",
      "MESSAGE_CREATED": "Utworzono wiadomość",
      "CONVERSATION_OPENED": "Otwarto rozmowę",
      "CONVERSATION_RESOLVED": "Rozwiązano rozmowę",
      "PHONE_CALL_FINISHED": "Zakończono połączenie"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Przypisz do agenta",
      "ASSIGN_TEAM": "Przypisz zespół",
      "ADD_LABEL": "Dodaj etykietę",
      "REMOVE_LABEL": "Usuń etykietę",
      "SEND_EMAIL_TO_TEAM": "Wyślij e-mail do zespołu",
      "SEND_EMAIL_TRANSCRIPT": "Wyślij transkrypt e-mailem",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Wyślij szczegółowy transkrypt e-mailem",
      "MUTE_CONVERSATION": "Wycisz rozmowę",
      "SNOOZE_CONVERSATION": "Odłóż rozmowę",
      "RESOLVE_CONVERSATION": "Zamknij rozmowę",
      "OPEN_CONVERSATION": "Otwórz rozmowę",
      "SEND_WEBHOOK_EVENT": "Wyślij zdarzenie webhook",
      "SEND_ATTACHMENT": "Wyślij załącznik",
      "SEND_MESSAGE": "Wyślij wiadomość",
      "ADD_NOTE": "Dodaj notatkę",
      "CHANGE_PRIORITY": "Zmień priorytet",
      "ADD_SLA": "Dodaj SLA",
      "SKIP_AUTO_PRIORITY": "Pomiń automatyczny priorytet",
      "SKIP_AUTO_LABELING": "Pomiń automatyczne etykietowanie",
      "AUTO_TRANSLATE": "Przetłumacz wiadomość",
      "AUTO_TRANSLATE_CONVERSATION": "Przetłumacz rozmowę",
      "MOVE_CONVERSATION_TO_INBOX": "Przenieś rozmowę do skrzynki",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Wyślij wiadomość w nowej rozmowie",
      "SEND_SMS_IN_NEW_CONVERSATION": "Wyślij SMS w nowej rozmowie",
      "STOP_PROCESSING_RULES": "Zatrzymaj przetwarzanie reguł"
    },
    "ATTRIBUTES": {
      "EXTENSION": "Wybrany numer wewnętrzny",
      "WORKING_HOURS": "W godzinach pracy",
      "AGENT_REPLIED": "Agent odpowiedział od zmiany statusu",
      "AI_FILTER": "Filtr AI",
      "MESSAGE_TYPE": "Typ wiadomości",
      "MESSAGE_CONTAINS": "Treść wiadomości",
      "EMAIL": "E-mail kontaktu",
      "INBOX": "Skrzynka odbiorcza",
      "CHANNEL_TYPE": "Typ skrzynki odbiorczej",
      "CONVERSATION_LANGUAGE": "Język rozmowy",
      "PHONE_NUMBER": "Numer telefonu",
      "STATUS": "Status",
      "BROWSER_LANGUAGE": "Język przeglądarki",
      "MAIL_SUBJECT": "Temat e-maila",
      "COUNTRY_NAME": "Kraj",
      "MARKETPLACE_COUNTRY": "Kraj marketplace",
      "REFERER_LINK": "Link odsyłający",
      "ASSIGNEE_NAME": "Przypisany",
      "TEAM_NAME": "Zespół",
      "PRIORITY": "Priorytet",
      "CALL_DIRECTION": "Kierunek połączenia",
      "MISSED_CALL": "Nieodebrane połączenie",
      "MISSED_CALL_COUNT": "Liczba nieodebranych połączeń",
      "MESSAGE_SOURCE_TYPE": "Typ źródła wiadomości",
      "INCOMING_MESSAGE_COUNT": "Liczba wiadomości przychodzących",
      "OUTGOING_MESSAGE_COUNT": "Liczba wiadomości wychodzących",
      "LABEL": "Etykieta",
      "EMAIL_RECIPIENTS": "Odbiorca e-maila",
      "EMAIL_AUTO_REPLY": "E-mail jest automatyczną odpowiedzią",
      "ATTACHMENT_EXTENSION": "Rozszerzenie załącznika"
    },
    "WAIT": {
      "RUN_LABEL": "Wykonaj akcje",
      "INSTANT": "Przy zdarzeniu",
      "DELAYED": "Z opóźnieniem",
      "TRIGGER_LABEL": "Czekaj, aż",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Rozmowa pozostaje w statusie",
        "CUSTOMER_UNRESPONSIVE": "Klient nie odpowiada agentowi",
        "AGENT_UNRESPONSIVE": "Klient nie otrzymuje odpowiedzi agenta"
      },
      "STATUS_LABEL": "Status",
      "STATUSES": {
        "OPEN": "Otwarta",
        "PENDING": "Oczekująca",
        "SNOOZED": "Odłożona",
        "RESOLVED": "Rozwiązana"
      },
      "DELAY_LABEL": "Czas oczekiwania",
      "DELAY_ERROR": "Podaj czas oczekiwania od 1 minuty do 30 dni",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} godz.",
        "DAYS": "{count} dn."
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Akcje zostaną wykonane, gdy rozmowa ma status {status} przez {duration}. Wcześniejsza zmiana statusu je anuluje. Etykiety, godziny pracy i odpowiedzi agentów są sprawdzane po zakończeniu oczekiwania.",
        "CUSTOMER_UNRESPONSIVE": "Akcje zostaną wykonane, gdy klient przez {duration} nie odpowie na wiadomość agenta. Odpowiedź klienta je anuluje; nowa wiadomość agenta rozpoczyna oczekiwanie od nowa.",
        "AGENT_UNRESPONSIVE": "Akcje zostaną wykonane, gdy klient czeka {duration} bez odpowiedzi agenta. Odpowiedź agenta je anuluje."
      }
    }
  }
}
